<mat-card class="info">
  <p>Atenção</p>
  <ul>
    <li>A carga horária da disciplina pertence integralmente ao(s) docente(s) responsável(is) pela disciplina.</li>
    <li>
      Não há atribuição de carga horária para o pós-graduando, mas apenas o total de horas de atividades de estágio
      demonstradas no plano de atividades.
    </li>
  </ul>
</mat-card>
